module.exports = __webpack_public_path__ + "static/img/banner.482f8cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A2/banner.png
// module id = lTKz
// module chunks = 0